import React from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { c, glassSurface } from "../../classroomColors";
import { firstName, roomMark } from "./roomPlan";

/**
 * Where you are, when it is not the class: under the class name, so it is
 * the first thing read. A student sees their room and who they are with; the
 * teacher sees which room they have dropped into, and the way back.
 */
const RoomBanner = ({ room, index, isTeacher, currentUserGuid, onLeave }) => {
  const others = room.members.filter((m) => m.guid !== currentUserGuid).map((m) => firstName(m.name));
  return (
    <Flex
      align="center"
      gap="10px"
      pl="14px"
      pr={isTeacher ? "6px" : "16px"}
      h="40px"
      borderRadius="200px"
      maxW="100%"
      {...glassSurface}
    >
      <Box boxSize="8px" borderRadius="full" bg={roomMark(index)} flexShrink={0} />
      <Text fontSize="13px" color={c.text} noOfLines={1}>
        <Box as="span" fontWeight="600">
          {isTeacher ? `In ${room.name}` : `You're in ${room.name}`}
        </Box>
        <Box as="span" color={c.textSub}>
          {isTeacher
            ? ` · ${room.members.length} ${room.members.length === 1 ? "student" : "students"}`
            : others.length
            ? ` · with ${others.join(", ")}`
            : " · just you for now"}
        </Box>
      </Text>
      {isTeacher && (
        <Button
          size="xs"
          h="28px"
          px="12px"
          borderRadius="200px"
          fontSize="12px"
          fontWeight="500"
          bg={c.solidBg}
          color={c.solidText}
          _hover={{ bg: c.solidBg, opacity: 0.86 }}
          onClick={onLeave}
          flexShrink={0}
        >
          Back to the class
        </Button>
      )}
    </Flex>
  );
};

export default RoomBanner;
